<template>
    <div class="contact">
        <div class="column" id="contact-office-nice">
            <div class="title">Nice</div>
            <line-footer />
            <div class="details">
                <p>
                    Indigen Solutions<br />29 Rue Pastorelli<br />06000 Nice,
                    France
                    <a
                        class="link"
                        target="_blank"
                        href="https://maps.app.goo.gl/6nzWt4noVt6vqgWz8"
                    >
                        See on map
                    </a>
                </p>
                <p>
                    Happy to hear from you at:
                    <a class="link" href="mailto:contact@indigen.com">
                        contact@indigen.com
                    </a>
                    <a class="link" href="tel:+33493550601">
                        +33 4 93 55 06 01
                    </a>
                </p>
            </div>
        </div>
        <div class="column" id="contact-office-cairo">
            <div class="title">Cairo</div>
            <line-footer />
            <p>
                Indigen Cairo<br />4, zone 1258, Abd El-Hameed Badawi ST,
                <br />Sheraton, Cairo, Egypt
                <a
                    class="link"
                    target="_blank"
                    href="https://maps.app.goo.gl/xvatRww77a7yCux89"
                >
                    See on map
                </a>
            </p>
            <p>
                Happy to hear from you at:
                <a class="link" href="mailto:contact@indigen.com">
                    ahlan@indigen.com
                </a>
                <a class="link" href="tel:+201275883258"> +20 12 75 88 3258 </a>
            </p>
        </div>
        <div class="column" id="contact-office-dubai">
            <div class="title">Dubai</div>
            <line-footer />
            <p>
                Indigen Middle-East L.L.C-FZ<br />
                The Meydan Hotel, Grandstand, 6th floor, <br />Meydan Road, Nad
                Al Sheba, Dubai, U.A.E
                <a
                    class="link"
                    target="_blank"
                    href="https://maps.app.goo.gl/p4n6peTyb5KMNheN8"
                >
                    See on map
                </a>
            </p>
            <p>
                Happy to hear from you at:
                <a class="link" href="mailto:contact@indigen.com">
                    ahlan@indigen.com
                </a>
                <a class="link" href="tel:+971504557665"> +971 50 455 7665 </a>
            </p>
        </div>
    </div>
</template>
<script>
import LineFooter from "@/components/LineFooter";
import getters from "@/mixins/getters.mixin";
import { clearScroll, scroll } from "@/services/scroll.animation";

export default {
    mixins: [getters],
    props: {
        mode: {
            type: String,
            default: "nice",
        },
    },
    components: {
        LineFooter,
    },
    computed: {
        id() {
            return `contact-section-office-${this.mode}`;
        },
        section() {
            return this.getSection(`offices_${this.mode}_hero`);
        },
    },
    mounted() {
        scroll(this.id, this.$el, this.section.colors);
    },
    beforeDestroy() {
        clearScroll(this.id);
    },
};
</script>

<style lang="sass" scoped>
@import ~include-media/dist/include-media
@import ~styles/base
@import ~styles/typography

.contact
    --section-padding: calc(var(--line-base) * 2)
    display: flex
    justify-content: space-between
    color: white
    flex-wrap: wrap

    +media('<small')
        text-align: center
        padding-top: var(--line-base)
        padding-bottom: var(--line-base)
        gap: calc(var(--line-base) * 2)


    svg
        display: block
        margin-left: auto
        margin-right: auto
        stroke: currentColor
        max-width: 50%

        +media('>=small')
            max-width: 16.667%


.column
    flex-basis: 50%
    box-sizing: border-box
    text-align: center

    +media('<small')
        flex-basis: 100%

.details
    display: flex
    flex-direction: column


.title
    text-align: center
    padding-bottom: calc(var(--line-base) * 1.5)

    +media('<small')
        margin-top: 0
.link
    display: block
    font-weight: 600
</style>
